import { render, staticRenderFns } from "./send-grid.vue?vue&type=template&id=0fa15d83&scoped=true&"
import script from "./send-grid.vue?vue&type=script&lang=js&"
export * from "./send-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa15d83",
  null
  
)

export default component.exports